import { useEffect, useState, FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../../../components/layout/Navbar";
import { Button } from "../../../components/Button";
import supabase from "../../../helper/supabaseClient";
import { toast } from "sonner";

const ChangePassword = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    newPassword1: "",
    newPassword2: "",
  });
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // Check if session exists after Supabase redirected back
  useEffect(() => {
    const checkSession = async () => {
      const { data, error } = await supabase.auth.getSession();
      if (error || !data.session) {
        toast.error("Your reset link is invalid or expired.");
        navigate("/reset-password");
      }
    };
    checkSession();
  }, [navigate]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError("");

    if (formData.newPassword1 !== formData.newPassword2) {
      setError("Passwords don't match");
      return;
    }

    if (!formData.newPassword1) {
      setError("Password cannot be empty");
      return;
    }

    try {
      setIsLoading(true);
      const { data, error } = await supabase.auth.updateUser({
        password: formData.newPassword1,
      });

      if (error) throw error;

      toast.success("Password reset successfully. Redirecting...");
      setTimeout(() => navigate("/login"), 2000);
    } catch (err) {
      console.error("Password reset failed:", err);
      toast.error(err instanceof Error ? err.message : "Failed to reset password");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <Navbar />
      <div className="p-5 h-[81vh] sm:p-14 flex items-start md:items-center justify-center landing-bg bg-cover bg-no-repeat bg-center">
        <div className="w-full md:w-fit flex items-center justify-center flex-col bg-white">
          <div className=" sm:p-10 rounded-2xl sm:border border-[#7E57C233]  w-[100%] sm:w-[80%] md:w-fit flex items-center justify-between gap-20 ">
            <div className="flex flex-col gap-6 items-start justify-start w-[500px]">
              <h2>Reset Password</h2>
              {error && <p className="text-red-500">{error}</p>}
              <form
                className="flex flex-col items-start justify-center gap-5 w-full"
                onSubmit={handleSubmit}
              >
                <div className="flex flex-col gap-1.5 w-full">
                  <label htmlFor="newPassword1" className="text-[#666666CC]">
                    Enter New Password
                  </label>
                  <input
                    type="password"
                    name="newPassword1"
                    id="newPassword1"
                    value={formData.newPassword1}
                    onChange={handleChange}
                    placeholder="Enter your password"
                    className="h-11 w-full border border-[#66666659] rounded-lg outline-0 px-3"
                    required
                  />
                </div>
                <div className="flex flex-col gap-1.5 w-full">
                  <label htmlFor="newPassword2" className="text-[#666666CC]">
                    Confirm New Password
                  </label>
                  <input
                    type="password"
                    name="newPassword2"
                    id="newPassword2"
                    value={formData.newPassword2}
                    onChange={handleChange}
                    placeholder="Enter your password again"
                    className="h-11 w-full border border-[#66666659] rounded-lg outline-0 px-3"
                    required
                  />
                </div>
                <Button
                  text={isLoading ? "Resetting..." : "Reset Password"}
                  disabled={isLoading}
                />
              </form>
            </div>
            <img
              src="/assets/Jellosite-Logo-09.jpg"
              alt=""
              className="w-[250px] hidden md:block"
            />
          </div>
          <ul className="text-[#666666] md:w-full hidden sm:flex gap-3.5 sm:w-[80%] items-center justify-end mt-1">
            <Link to="/privacy_policy">
              <li>Privacy</li>
            </Link>
            <Link to="/terms_conditions">
              <li>Terms</li>
            </Link>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
